'use strict';

angular.module('AcaApp').controller('SendXmitToStateController',
  [
    '$scope',
    '$mdDialog',
    'XmitToStateService',
    'UtilsService',
    'file',
    function($scope, $mdDialog, XmitToStateService, UtilsService, file){
      $scope.formChanged = false;
      $scope.stateEnabled = (file.state);
      $scope.confirmationNumbEnabled = (file.confirmationnumber);
      $scope.form = {
        state: file.state,
        confirmationnumber: file.confirmationnumber,
        xmitrun: file.xmitrun,
        filename: file.filename,
        generated: file.createdate,
        status: file.status
      };
      $scope.$watch('form', _formChanged, true);

      var stateOld = file.states;

      function _formChanged(newValue, oldValue){
        if(newValue !== oldValue){
          $scope.formChanged = true;
        }
      }

      $scope.saveXmitToState = function(){
        var actionToDo = (stateOld) ? 'update' : 'save';
        XmitToStateService.saveXmitFileToState($scope.form, actionToDo).then(
          function(data){
            if(!data.result.value){
              $mdDialog.hide().finally(function(){
                $scope.$parent.goToSendTransmittalState();
              });
              showModalmessage();
            }
          },
          function(error){
            $scope.errorMessage = error.data.error.frontend_message;
          }
        );

      };

      $scope.closeModal = function(){
        $mdDialog.hide();
      };

      var showModalmessage = function(){
        $mdDialog.show({
          scope: $scope,
          preserveScope: true,
          controller: [
            '$scope',
            '$rootScope',
            '$mdDialog',
            function($scope, $rootScope, $mdDialog){
              $scope.closeModal = function(){
                $mdDialog.hide();
              };
            }
          ],
          templateUrl: 'app/views/send/modals/message-xmit-to-state.html'
        });
      };
    }
  ]);